import { render, staticRenderFns } from "./next-number.vue?vue&type=template&id=45147c1d&functional=true"
import script from "./next-number.vue?vue&type=script&lang=js"
export * from "./next-number.vue?vue&type=script&lang=js"
import style0 from "./next-number.vue?vue&type=style&index=0&id=45147c1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports